/* eslint-disable no-unused-vars */
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { Link as Scroll } from "react-scroll";
import React, { useState, useRef, useEffect } from "react";
import "../App.css";
import AlcoholSection from "../context/AlcoholSection";
import "../Home.css";
import gsap from "gsap";
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase";
import Header from "./Header";
import ScrollFadeIn from "../context/ScrollFadeIn";

function Home() {
  // const createDummyData = (recommend) => [
  //   {
  //     image: " ",
  //     name: `${prefix} 1`,
  //     description: `${prefix}の説明 1`,
  //   },
  //   {
  //     image: `${prefix}`,
  //     name: `${prefix} 2`,
  //     description: `${prefix}の説明 2`,
  //   },
  // ];

  // const vodkaData = createDummyData("Vodka");
  // const tequilaData = createDummyData("Tequila");
  // const ginData = createDummyData("GIN");
  // const rumData = createDummyData("Rum");
  // const nihonshuData = createDummyData("日本酒");
  // const shochu = createDummyData("焼酎");

  const VodkaRef = useRef(null);
  const TequilaRef = useRef(null);
  const RumRef = useRef(null);
  const GinRef = useRef(null);
  const SyoucyuRef = useRef(null);
  const NihonnsyuRef = useRef(null);
  const HomerRef = useRef(null);
  const headerRef = useRef();
  const aRef = useRef(null);
  const bRef = useRef(null);
  const cRef = useRef(null);
  const dRef = useRef(null);
  const eRef = useRef(null);

  // ボタンクリック時にスクロールする関数
  const handleScroll = (scrollSettion) => {
    // VodkaRef.current.scrollIntoView({ behavior: 'smooth' });
    const HeaderHeight = headerRef.current.offsetHeight;
    const ScrollTop =
      scrollSettion.current.getBoundingClientRect().top +
      window.pageYOffset -
      HeaderHeight -
      100;
    window.scrollTo({ top: ScrollTop, behavior: "smooth" });
    setcondition(false);
  };
  const isMobile = window.innerWidth<=768

  const [condition, setcondition] = useState(false);
  const formclick = () => {
    if (!isMobile){setcondition(!condition)}
    else {handleScroll(eRef)}
    
  };

  const location = useLocation();
  const navigate = useNavigate();

  const scrollNavi = (cocktail) => {
    navigate(
      "/happy",
      {
        state: {
          base: cocktail,
          taste: "",
          alcoholContent: "",
          carbonation: "",
        },
      },
      [location]
    );
    console.log(cocktail);
  };

  return (
    <>
      <body>
        <div className="main-body">
          <div ref={headerRef}></div>
          <div className="topbar">
            <p onClick={() => handleScroll(aRef)}>カクテルとはは</p>
            <span>|</span>
            <p onClick={() => handleScroll(bRef)}>主なベースのお酒</p>
            <span>|</span>
            <p onClick={() => handleScroll(cRef)}>カクテルの種類</p>
            <span>|</span>
            <p onClick={() => handleScroll(dRef)}>カクテルの作成技法</p>
            <span>|</span>
            <p className="toprecommend" onClick={formclick}>
              おすすめのお酒
            </p>
            <p></p>
            <div className="sidebar">
              {condition ? (
                <>
                  <p
                    onClick={() => handleScroll(VodkaRef)}
                    className="list-item no-before"
                  >
                    Vodka
                  </p>
                  <p
                    onClick={() => handleScroll(TequilaRef)}
                    className="list-item"
                  >
                    Tequila
                  </p>
                  <p onClick={() => handleScroll(GinRef)} className="list-item">
                    GIN
                  </p>
                  <p onClick={() => handleScroll(RumRef)} className="list-item">
                    Rum
                  </p>
                  <p
                    onClick={() => handleScroll(NihonnsyuRef)}
                    className="list-item"
                  >
                    ウイスキー
                  </p>
                  <p
                    onClick={() => handleScroll(SyoucyuRef)}
                    className="list-item"
                  >
                    焼酎
                  </p>
                </>
              ) : null}
            </div>
          </div>

          <div className="first">
            <h4 ref={aRef}>カクテルとは</h4>
            <div className="explain">
              <p>
                カクテルはミクスト・ドリンク（MixedDrink）のこと。
                氷や器具を使って冷やしながら酒と何かを混ぜたり、あるいは温かい飲み物と酒を混ぜたりといろんな方法でつくられたものをカクテルという。
                簡単にいえばある酒に別の酒をミックスしたり、ソーダ水やソフトドリンクなど何かを加えて、新たな味わいを創作したものである。
                カクテル＝酒＋何か、つまり、何気なく飲んでいるウイスキーの水割やソーダ水割（ハイボール）もカクテルになる。こうしたシンプルなミックスによってでき上がるカクテルもあれば、つくり手、飲み手の創意工夫によるさまざまな何かと組み合わせて生まれるカクテルもある。
                組み合わせは自由であり、それゆえに数えきれないほどのカクテルが誕生していく。
              </p>
            </div>
          </div>
          <div className="second">
            <h4 ref={bRef}>主なベースのお酒</h4>
            <div ref={HomerRef} id="heder-scroll" className="image-wrapper">
              <div className="base vodka">
                <img
                  onClick={() => scrollNavi("ウォッカ")}
                  src="./picture/18973b2c0c4ae08f53d837eca48c55c9.jpg"
                />
                <p id="vodka-scroll">Vodka</p>
              </div>
              <div className="base tequila">
                <img
                  onClick={() => scrollNavi("テキーラ")}
                  src="./picture/01.jpg"
                />
                <p>Tequila</p>
              </div>
              <div onClick={() => scrollNavi("ジン")} className="base gin">
                <img src="./picture/36547.jpg" />
                <p>GIN</p>
              </div>
              <div onClick={() => scrollNavi("ラム")} className=" base rum">
                <img src="./picture/15752.jpg" />
                <p>Rum</p>
              </div>{" "}
              <div
                onClick={() => scrollNavi("ウイスキー")}
                className="base nihonsyu"
              >
                <img src="./picture/images.jpg" />
                <p> whisky</p>
              </div>
              <div onClick={() => scrollNavi("焼酎")} className="base syochu">
                <img src="./picture/01 (1).jpg" />
                <p>焼酎</p>
              </div>
            </div>
          </div>
          <div className="third">
            <h4 ref={cRef}>カクテルの種類</h4>
            <div className="kind">
              <h5>ロングドリンク</h5>
              <ul>
                <li>
                  比較的容量が多く、氷を使ってさっぱりとした飲み心地に仕上げるもの。
                </li>
                <li>例: モスコミュール、ジントニック、スクリュードライバー</li>
              </ul>
              <h5>ショートドリンク</h5>
              <ul>
                <li>
                  容量が少なく、アルコール度数が高いものが多い。食事の後や特別な場面で飲まれることが多い。
                </li>
                <li>例: マティーニ、マルガリータ、ダイキリ</li>
              </ul>
              <h5>ノンアルコールカクテル（モクテル）</h5>
              <ul>
                <li>
                  アルコールを含まないカクテル。ジュースやシロップ、炭酸水などで作られる。
                </li>
                <li>例: シャーリーテンプル、ヴァージンモヒート</li>
              </ul>
            </div>
          </div>
          <div className="forth">
            <h4 ref={dRef}>カクテルの作成技法</h4>
            <div className="skill">
              <ScrollFadeIn>
                <div className="skill-detail shake">
                  <img src="./6946.jpg" />
                  <div>
                    <h6>シェイク</h6>
                    <p>
                      シェイカーに氷と共に材料を入れシェイカーを振ることにより材料を混ぜる技法（ただし、非常に混ざりにくい材料を混合する場合は、氷を入れる前に、予めシェイカーの中でバー・スプーンなどを使ってステアすることで材料を溶いてしまう場合もある）。この技法は、材料を混合することと冷却することを、主な目的としている。
                    </p>
                  </div>
                </div>
              </ScrollFadeIn>
              <ScrollFadeIn>
                <div className="skill-detail ster">
                  <img src="./6950.jpg" />
                  <div>
                    <h6>ステア</h6>
                    <p>
                      混ざりやすい幾つかの材料を、氷を入れたミキシング・グラスに注ぎ、バー・スプーンなどで手早くかき混ぜる技法。この技法は、材料を混合することと冷却することを目的としている。
                    </p>
                  </div>
                </div>
              </ScrollFadeIn>
              <ScrollFadeIn>
                <div className="skill-detail bild">
                  <img src="./6942.jpg" />
                  <div>
                    <h6>ビルド</h6>
                    <p>
                      直接グラスに氷や酒類などの材料を注いで作る技法。なお、この方法で冷たいロングドリンク（ロングカクテル）を作る場合で、氷を使用する時は、予めグラスに氷を入れた上で、その他の材料を入れる。この方法で作った場合、グラスに材料を注いだ後で、しばしばステアが行われる。ただし、ステアする場合でも、ステアの前に炭酸を含む材料を加えた場合、炭酸が二酸化炭素となって逃げてしまい、味が悪くならないように注意する必要がある。
                    </p>
                  </div>
                </div>
              </ScrollFadeIn>
              <ScrollFadeIn>
                <div className="skill-detail blemd">
                  <img src="./frozen_blue_margarita.jpg" />
                  <div>
                    <h6>ブレンド</h6>
                    <p>
                      ブレンダー（ミキサー）を使い、材料とクラッシュド・アイスを細かく混ぜる技法。フローズン・スタイルのカクテルはこの技法で作られる。
                    </p>
                  </div>
                </div>
              </ScrollFadeIn>
              <ScrollFadeIn>
                <div className="skill-detail float">
                  <img src="./step_03_large.jpg" />
                  <div>
                    <h6>フロート</h6>
                    <p>
                      比重の違う液体を混ざらないように静かに注ぎ、重ねる技法。
                      なお、カクテルのスタイルを指す場合は、2種類の液体を使って作ったプース・カフェ・スタイルのカクテルのことを言う。
                    </p>
                  </div>
                </div>
              </ScrollFadeIn>
            </div>
          </div>
          <div className="container-wrapper" >
            <h4 ref={eRef}>おすすめのお酒</h4>
            <div className="home-container">
              <div>
                <h2 ref={VodkaRef} >Vodkaのオススメ</h2>
                {/* <AlcoholSection items={vodkaData} /> */}
                <AlcoholSection baseName={"ウォッカ"} />
              </div>

              <div>
                <h2 ref={TequilaRef}>Tequilaのオススメ</h2>
                {/* <AlcoholSection items={tequilaData} /> */}
                <AlcoholSection baseName={"テキーラ"} />
              </div>

              <div>
                <h2 ref={GinRef}>GINのオススメ</h2>
                {/* <AlcoholSection items={ginData} /> */}
                <AlcoholSection baseName={"ジン"} />
              </div>

              <div>
                <h2 ref={RumRef}>Rumのオススメ</h2>
                {/* <AlcoholSection items={rumData} /> */}
                <AlcoholSection baseName={"ラム"} />
              </div>

              <div>
                <h2 ref={NihonnsyuRef}>Whiskyのオススメ</h2>
                {/* <AlcoholSection items={nihonshuData} /> */}
                <AlcoholSection baseName={"ウイスキー"} />
              </div>

              <div>
                <h2 ref={SyoucyuRef}>焼酎のオススメ</h2>
                {/* <AlcoholSection items={shochu} /> */}
                <AlcoholSection baseName={"焼酎"} />
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default Home;
